var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampainNameDitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-pencil-line-lined",
    d: "M19,20.25a.772.772,0,0,0-.75-.75H3.75a.75.75,0,0,0,0,1.5h14.5A.772.772,0,0,0,19,20.25Zm-7.4-3.4,9.124-9.125A.982.982,0,0,0,21,7.043a.921.921,0,0,0-.28-.662L17.6,3.277a.954.954,0,0,0-1.344,0l-9.143,9.1c-.569,1.763-1.555,4.823-1.626,5.081a.867.867,0,0,0-.029.224.819.819,0,0,0,.765.848c.511,0,.991-.189,5.369-1.681ZM8.327,13.51l2.137,2.137L7.3,16.693Zm.955-1.166,7.651-7.616,2.335,2.327-7.637,7.638Z",
    transform: "translate(-3 -3)",
    fill: "#6d7077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampainNameDitIcon);
export default __webpack_public_path__ + "static/media/campain-name-dit-icon.0314fe0f51a4aa346bc810d17eaecaf9.svg";
export { ForwardRef as ReactComponent };